import { useMemo, useState } from 'react';
import { Checkbox, Divider, Input, Select, type SelectProps } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export interface SelectAllMultipleOption {
  value: string;
  label: string;
}

interface SelectAllMultipleProps
  extends Omit<
    SelectProps<string[]>,
    'mode' | 'options' | 'open' | 'onOpenChange' | 'popupRender' | 'showSearch' | 'searchValue' | 'onSearch'
  > {
  options: SelectAllMultipleOption[];
}

export function SelectAllMultiple({ options, value, onChange, ...selectProps }: SelectAllMultipleProps) {
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const selected = value ?? [];
  const allValues = useMemo(() => options.map((option) => option.value), [options]);
  const allSelected = allValues.length > 0 && allValues.every((v) => selected.includes(v));

  const closeDropdown = () => setOpen(false);

  return (
    <Select
      {...selectProps}
      mode="multiple"
      options={options}
      value={value}
      onChange={onChange}
      open={open}
      onOpenChange={(next) => {
        setOpen(next);
        if (!next) setSearchValue('');
      }}
      showSearch
      searchValue={searchValue}
      onSearch={setSearchValue}
      optionFilterProp="label"
      popupRender={(menu) => (
        <>
          <div style={{ padding: '8px 12px 4px' }}>
            <Input
              variant="borderless"
              prefix={<SearchOutlined style={{ color: '#6b6b6b' }} />}
              placeholder="Search..."
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              onMouseDown={(event) => event.stopPropagation()}
              style={{ padding: 0 }}
            />
          </div>
          <Divider style={{ margin: '0 0 4px' }} />
          {allValues.length > 0 && (
            <div
              style={{ padding: '5px 12px', cursor: 'pointer' }}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => onChange?.(allSelected ? [] : allValues)}
            >
              <Checkbox checked={allSelected} onChange={() => {}}>(Chọn tất cả)</Checkbox>
            </div>
          )}
          {menu}
          <Divider style={{ margin: '4px 0 0' }} />
          <div style={{ display: 'flex' }}>
            <div
              role="button"
              style={{ flex: 1, textAlign: 'center', padding: '10px 0', cursor: 'pointer' }}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => onChange?.([])}
            >
              Xoá hết
            </div>
            <div style={{ width: 1, background: '#f0f0f0' }} />
            <div
              role="button"
              style={{ flex: 1, textAlign: 'center', padding: '10px 0', cursor: 'pointer' }}
              onMouseDown={(event) => event.preventDefault()}
              onClick={closeDropdown}
            >
              Đóng
            </div>
          </div>
        </>
      )}
    />
  );
}

export default SelectAllMultiple;
